import React from "react";
import VideoChat from "./components/VideoChat";

export default function App() {
    return (
        <div>
            <VideoChat />
        </div>
    );
}
